<template>
  <div class="input-container" :class="{'login-email-input': regFlowLogin}">
    <input
      v-bind="field"
      :data-testid="elementId"
      :id="elementId"
      :type="type"
      :disabled="disabledVal"
      :placeholder="placeholderText"
      class="dropdown-box"
      :value="modelValue"
      :maxlength="maxLength"
      @input="$emit('update', $event.target.value)"
      @blur="$emit('blur', $event)"
      :class="{'pt-20' : modelValue, 'pt-20--tooltip' : tooltipEnabled}"
      ref="focusInput"/>
    <span class="input-placeholder" :class="{'animate' : modelValue || !animatePlaceholderToLabel}">{{label}}</span>
    <div class="outer-tooltip-container" v-if="tooltipEnabled" v-tooltip="tooltipOptions">
      <span :class="tooltipOptions.iconClasses"></span>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import { floatLabel } from "@/utils/helper.js";
import { useGlobal } from '@/composables/';

// Define component name
defineOptions({
  name: 'InputBox'
});

// Props
const props = defineProps({
  placeholderText: {
    type: String,
    default: " ",
  },
  modelValue: [String, Boolean, Number],
  label: String,
  type: String,
  disabledVal: Boolean,
  errorMessage: String,
  maxLength: String,
  id: String,
  autofocusVal: Boolean,
  regFlowLogin: Boolean,
  animatePlaceholderToLabel: {
    type: Boolean,
    default: true,
  },
  tooltipEnabled: {
    type: Boolean,
    default: false,
    required: false,
  },
  tooltipOptions: {
    type: Object,
    default: () => {
      return {
        placement: 'top',
        classes: [''],
        offset: 0,
        delay: {
          show: 600,
          hide: 500,
        },
        content: '',
      };
    },
  },
  field: Object,
});

// Emits
defineEmits(['update', 'blur']);

// Composables
const { isIeOrEdge } = useGlobal();

// Reactive data
const model = ref("");
const focusInput = ref(null);

// Computed properties
const elementId = computed(() => {
  return props.id || props.label;
});

// Methods
const animateAutoFillIE = () => {
  let elementId = props.id || props.label;
  floatLabel(elementId, "pt-20", "animate");
};

// Watchers
watch(() => props.autofocusVal, (newVal) => {
  if (newVal) {
    focusInput.value.focus();
  }
});

// Lifecycle hooks
onMounted(() => {
  if (isIeOrEdge.value) {
    animateAutoFillIE();
  }
  if (props.autofocusVal) {
    focusInput.value.focus();
  }
});
</script>

<style src="./styles.css"></style>
<style lang="stylus" scoped>
.input-container {
  position: relative;
}
.pt-20 {
  padding-top: 20px;
  &&--tooltip {
    max-width: calc(100% - 30px);
  }
}

.login-email-input {
  border: 1px solid #D3D3D3;
  border-radius: 4px;
   &:focus-within {
     border: 1px solid #2E90FA;
     border-radius: 4px;
   }
  .dropdown-box {
    font-family: 'Lato',sans-serif;
    border-bottom: none;
    font-size: 14px;
    color: #3a4145;
  }
  input {
    height: 40px;
    margin-top: 0;
    padding-top: 0;
  }
  .input-placeholder {
    font-size: 14px;
    font-family: 'Lato',sans-serif;
    max-width: calc(100% - 50px) !important;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding: 12px 0 12px 10px !important;
  }
  .animate, input:focus + span {
    font-size:11px;
    background-color: #fff;
    width: auto;
    padding: 0px 2px 2px 2px !important;
    transform: translateY(-6.5px) translateX(10px);
  }
  input:focus + span{
    color: #2E90FA;
  }
  // .dropdown-box:focus + .animate, input:focus + span{
  //   color: #2E90FA;
  // }
  .outer-tooltip-container{
    position: absolute;
    right: 0;
    top: 0;
    background-color: #F7F7F7;
    width: 32px;
    height: 40px;
    text-align: center;
  }
}
</style>
